export interface BackendConfig {
  apiBaseUrl: string;
  environment: string;
  corsEnabled: boolean;
}

// Environment-specific backend configurations
const backendConfigs: Record<string, BackendConfig> = {
  development: {
    apiBaseUrl: 'http://localhost:5003',
    environment: 'development',
    corsEnabled: true
  },
  production: {
    apiBaseUrl: 'https://auditio-backend-1011599919414.us-central1.run.app',
    environment: 'production',
    corsEnabled: true
  }
};

// Get current environment
const getCurrentEnvironment = (): string => {
  // Check if we're in development (localhost) or production (vercel or pricha.net)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
    if (hostname.includes('vercel.app') || hostname.includes('pricha.net')) {
      return 'production';
    }
  }
  
  // Fallback to environment variable or default to development
  return process.env.NODE_ENV || 'development';
};

// Get API base URL from environment variables or fallback to config
const getApiBaseUrl = (env: string): string => {
  // Check for REACT_APP_API_BASE_URL (React apps use REACT_APP_ prefix)
  if (process.env.REACT_APP_API_BASE_URL) {
    console.log('🔧 Using REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Fallback to hardcoded config
  const config = backendConfigs[env] || backendConfigs.development;
  console.log('🔧 Using hardcoded API URL:', config.apiBaseUrl);
  return config.apiBaseUrl;
};

// Get backend configuration for current environment
export const getBackendConfig = (): BackendConfig => {
  const env = getCurrentEnvironment();
  const baseConfig = backendConfigs[env] || backendConfigs.development;
  
  // Override apiBaseUrl with environment variable if available
  return {
    ...baseConfig,
    apiBaseUrl: getApiBaseUrl(env)
  };
};

// Export the current configuration
export const backendConfig = getBackendConfig();

// Log configuration on import (development only)
if (backendConfig.environment === 'development') {
  console.log('🔧 Backend Configuration:', {
    environment: backendConfig.environment,
    apiBaseUrl: backendConfig.apiBaseUrl,
    corsEnabled: backendConfig.corsEnabled
  });
} 